export const FETCH_TASK = "app/News/FETCH_TASK";
export const FETCH_TASK_SUCCESS = "app/News/FETCH_TASK_SUCCESS";
export const FETCH_TASK_FAILURE = "app/News/FETCH_TASK_FAILURE";

export const TOGGLE_TASK_MODAL = "app/News/TOGGLE_TASK_MODAL";
